module.exports = __webpack_public_path__ + "assets/img/title-2914a9b9.png";